import Model from "./base/model";

class RequestInvoice extends Model {
  resourceName() {
    return "request_invoices";
  }

  fields() {
    return {
      number: "",
      name: "",
      path: "",
    };
  }
}

export default new RequestInvoice();
